import { createAsyncThunk } from '@reduxjs/toolkit';
import { IJsonQueryDistrict } from '../../../../packages/api-models/common/json_query';
import { getGeoValueByType } from '../../../../packages/JsonQuery';
import { MOSCOW_ID, SPB_ID } from 'shared/constants/regions';
import { selectJsonQuery } from 'shared/selectors/jsonQuery';
import { selectLocation } from 'shared/selectors/location';
import { fetchDistrictsTree } from 'shared/services/fetchDistrictsTree';
import { IGeoDistrict } from 'shared/types/geo';
import { TLocation } from 'shared/types/location';
import { IThunkApi } from 'shared/types/redux';
import { IDistrictsDataPayload } from 'shared/slices/geo/types';

export const loadDistrictsTree = createAsyncThunk<IDistrictsDataPayload, void, IThunkApi>(
  'geo/districtsSwitcher/loadData',
  async (_, thunkApi) => {
    const { getState, extra: context } = thunkApi;
    const state = getState();

    const currentLocation = selectLocation(state);

    const jsonQuery = selectJsonQuery(state);

    const selectedDistricts = getGeoValueByType<IJsonQueryDistrict>('district')(jsonQuery) || [];

    let districts: IGeoDistrict[];

    try {
      const result = await fetchDistrictsTree(context, { locationId: getRegionId(currentLocation) });

      districts = result;
    } catch (e) {
      districts = [];
    }

    return {
      selectedDistricts,
      districts,
    };
  },
);

function getRegionId(location: TLocation) {
  switch (location) {
    case 'moscow_mo':
      return MOSCOW_ID;
    case 'spb_lo':
      return SPB_ID;
    default:
      return location.id;
  }
}
